/* eslint-disable */
export default {
  unmute: 'Riattiva audio',
  mute: 'Disatt. audio',
  keypad: 'Tastiera',
  hold: 'Metti in attesa',
  onHold: 'In attesa',
  park: 'Parcheggia',
  stopRecord: 'Interrompi',
  record: 'Registra',
  add: 'Aggiungi',
  transfer: 'Trasferisci',
  flip: 'Commuta',
  more: 'Azioni chiamata',
  mergeToConference: 'Unisci',
  end: 'Termina',
  completeTransfer: 'Completa\ntrasferimento',
} as const;

// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"park"@#@ @source: @#@"Park"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"more"@#@ @source: @#@"Call Actions"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete\nTransfer"@#@
